var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable } from 'mobx';
import Storage from 'helpers/Storage';
export default class SettingsStore {
    constructor() {
        this.settings = {
            editablePrice: false,
            scanMultiple: true,
            rotateCamera: false
        };
        this._catalogSelected = Catalog.Stretches;
        this._saleSelected = Catalog.Stretches;
        this.rehydrate = () => {
            this.set(Storage.getJSON(SETTINGS_STORE));
        };
        this.set = (settings) => {
            Object.assign(this.settings, settings);
            this.persist();
        };
        this._showCashdesk = false;
        this._pinpadConnected = { isConnected: false };
        this.settings.rotateCamera = false;
        this.rehydrate();
    }
    get menuFocused() {
        return this._showCashdesk;
    }
    get pinpadConnected() {
        // console.log('_pinpadConnected: ', this._pinpadConnected)
        return this._pinpadConnected.isConnected;
    }
    get saleSelected() {
        return this._saleSelected;
    }
    get catalogSelected() {
        return this._catalogSelected;
    }
    setCatalogSelected(value) {
        this._catalogSelected = value;
    }
    setSaleSelected(value) {
        this._saleSelected = value;
    }
    setShowCashdesk(value) {
        // console.log('Settings - setShowCashdesk - value: ', value)
        this._showCashdesk = value;
    }
    setRotateCamera(value) {
        this.settings.rotateCamera = value;
        this.persist();
    }
    setScanMultiple(value) {
        this.settings.scanMultiple = value;
        this.persist();
    }
    persist() {
        return Storage.set(SETTINGS_STORE, this.settings);
    }
    setPinpadConnected(connected) {
        console.log('cambiando pinpadConnected a: ', connected);
        this._pinpadConnected.isConnected = connected;
    }
}
__decorate([
    observable
], SettingsStore.prototype, "settings", void 0);
__decorate([
    observable
], SettingsStore.prototype, "_catalogSelected", void 0);
__decorate([
    observable
], SettingsStore.prototype, "_saleSelected", void 0);
__decorate([
    observable
], SettingsStore.prototype, "_showCashdesk", void 0);
__decorate([
    observable
], SettingsStore.prototype, "_pinpadConnected", void 0);
__decorate([
    action
], SettingsStore.prototype, "setCatalogSelected", null);
__decorate([
    action
], SettingsStore.prototype, "setSaleSelected", null);
__decorate([
    action
], SettingsStore.prototype, "setShowCashdesk", null);
__decorate([
    action
], SettingsStore.prototype, "setRotateCamera", null);
__decorate([
    action
], SettingsStore.prototype, "setScanMultiple", null);
__decorate([
    action
], SettingsStore.prototype, "set", void 0);
__decorate([
    action
], SettingsStore.prototype, "setPinpadConnected", null);
const SETTINGS_STORE = 'SETTINGS_STORE';
export const Catalog = {
    Stretches: 'stretches',
    Articles: 'articles',
    Packets: 'packets',
    Bonuses: 'bonos',
    CollaboratorStretches: 'collaboratorStretches'
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/Settings/SettingsStore.ts
// module id = 114
// module chunks = 0